import { Link, List, Text } from "@wayflyer/flyui";
import { useIntl } from "react-intl";

import { UploadDocumentType } from "../../../types";

import { DocumentUpload } from "./document-upload";
import { MESSAGES } from "./message-definitions";

export const CashFlowForecastDocumentUpload = ({ includeHeader = false }: { includeHeader?: boolean }): UIElement => {
  const intl = useIntl();

  return (
    <DocumentUpload
      documentType={UploadDocumentType.CASH_FLOW_FORECAST}
      supportedFileExtensions={[".xlsx", ".csv", ".pdf"]}
      fileSizeLimitMB={10}
      header={includeHeader ? intl.formatMessage(MESSAGES.revenueProjectionsTitle) : undefined}
      description={
        <List type="bullet">
          <List.Item>
            <Text>
              {intl.formatMessage(MESSAGES.revenueProjectionsDescriptionPoint1, {
                a: (chunks: string) => (
                  <Link
                    url="https://docs.google.com/spreadsheets/d/1Y3cDnEuB134Zd8z4tLJY5ageeQUpNHMRwHPST4TrXnI/edit?gid=0#gid=0"
                    external
                  >
                    {chunks}
                  </Link>
                ),
              })}
            </Text>
          </List.Item>
          <List.Item>
            <Text>{intl.formatMessage(MESSAGES.cashFlowForecastDescriptionPoint2)}</Text>
          </List.Item>
        </List>
      }
    />
  );
};
